(() => {
  if (window.sfsContentEditorLoaded) return;
  window.sfsContentEditorLoaded = true;
  const controllers = new WeakMap();

  function initBenefits(root) {
    if (controllers.has(root)) return;
    const track = root.querySelector('.fae-features-strip__container');
    const items = [...root.querySelectorAll('.fae-features-strip__item')];
    if (!track || !items.length) return;
    let current = 0, timer = null, startX = 0;
    const mobile = () => window.innerWidth <= 768;
    const stop = () => { clearInterval(timer); timer = null; };
    const show = index => {
      if (!mobile()) return;
      const previous = current;
      current = (index + items.length) % items.length;
      items.forEach((item, i) => {
        item.classList.remove('is-active', 'slide-out-left');
        if (i === current) item.classList.add('is-active');
        else if (i === previous) item.classList.add('slide-out-left');
      });
    };
    const start = () => { stop(); if (mobile()) timer = setInterval(() => show(current + 1), 3200); };
    const resize = () => {
      if (mobile()) { show(current); start(); }
      else { stop(); items.forEach(item => item.classList.remove('is-active', 'slide-out-left')); }
    };
    track.addEventListener('touchstart', event => { startX = event.changedTouches[0].screenX; stop(); }, { passive: true });
    track.addEventListener('touchend', event => {
      const distance = event.changedTouches[0].screenX - startX;
      if (Math.abs(distance) > 40) show(current + (distance < 0 ? 1 : -1));
      start();
    }, { passive: true });
    window.addEventListener('resize', resize);
    controllers.set(root, {
      select(target) { const index = items.findIndex(item => item === target || item.contains(target)); if (index >= 0) { stop(); show(index); } },
      start,
      destroy() { stop(); window.removeEventListener('resize', resize); }
    });
    start();
  }

  function initNewsletter(root) {
    if (root.dataset.newsletterInitialized) return;
    const form = root.querySelector('form');
    const input = root.querySelector('input[type="email"]');
    const button = root.querySelector('button[type="submit"]');
    const message = root.querySelector('[data-newsletter-message]');
    if (!form || !input || !button || !message) return;
    root.dataset.newsletterInitialized = 'true';
    const display = (text, success) => {
      message.textContent = text;
      message.className = `fae-newsletter__msg fae-newsletter__msg--${success ? 'success' : 'error'}`;
      message.style.display = 'block';
    };
    form.addEventListener('submit', event => {
      event.preventDefault();
      const email = input.value.trim();
      if (!email || !email.includes('@')) { display(root.dataset.invalidText, false); return; }
      button.disabled = true;
      button.textContent = root.dataset.loadingText;
      fetch(form.action || '/contact#contact_form', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
        .then(() => {
          display(root.dataset.successText, true); input.value = ''; button.disabled = false; button.textContent = root.dataset.subscribedText;
        })
        .catch(() => {
          display(root.dataset.successText, true); input.value = ''; button.disabled = false; button.textContent = root.dataset.buttonText;
        });
    });
  }

  function initialize(scope = document) {
    scope.querySelectorAll('.fae-features-strip').forEach(initBenefits);
    scope.querySelectorAll('.fae-newsletter').forEach(initNewsletter);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.fae-features-strip').forEach(root => controllers.get(root)?.destroy()));
  document.addEventListener('shopify:block:select', event => controllers.get(event.target.closest('.fae-features-strip'))?.select(event.target));
  document.addEventListener('shopify:block:deselect', event => controllers.get(event.target.closest('.fae-features-strip'))?.start());
})();
